import { useState } from "react";

// ── BRAND ─────────────────────────────────────────────────────────────────────
const C = {
  orange:  "#FF6B00",
  orange2: "#FF8C00",
  orangeL: "#FFF4EC",
  white:   "#FFFFFF",
  bg:      "#F7F8FA",
  card:    "#FFFFFF",
  border:  "#EEEEEE",
  text:    "#1A1A1A",
  sub:     "#555555",
  muted:   "#999999",
  green:   "#16A34A",
  blue:    "#2563EB",
  red:     "#DC2626",
  purple:  "#7C3AED",
  teal:    "#0D9488",
  yellow:  "#D97706",
};

// ── SPORTS ────────────────────────────────────────────────────────────────────
const SPORTS = [
  { id:"all",        label:"All",        emoji:"🏆", color:C.orange  },
  { id:"cricket",    label:"Cricket",    emoji:"🏏", color:"#16A34A" },
  { id:"badminton",  label:"Badminton",  emoji:"🏸", color:"#2563EB" },
  { id:"football",   label:"Football",   emoji:"⚽", color:"#DC2626" },
  { id:"tennis",     label:"Tennis",     emoji:"🎾", color:"#D97706" },
  { id:"pickleball", label:"Pickleball", emoji:"🥒", color:"#7C3AED" },
  { id:"hockey",     label:"Hockey",     emoji:"🏑", color:"#0D9488" },
];

function sportColor(id){ return SPORTS.find(s=>s.id===id)?.color || C.orange; }
function sportEmoji(id){ return SPORTS.find(s=>s.id===id)?.emoji || "🏆"; }

// ── SAMPLE DATA ───────────────────────────────────────────────────────────────
const COACHES = [
  { id:1, name:"Ravi Shankar",    sport:"cricket",    exp:"12 yrs", area:"Gachibowli",     ground:"Gachibowli Stadium",                 price:800,  rating:4.8, students:34, wa:"919876543210", specialty:"Batting & Technique" },
  { id:2, name:"Priya Menon",     sport:"badminton",  exp:"8 yrs",  area:"Hitech City",    ground:"Hitech City Badminton Academy",       price:600,  rating:4.9, students:28, wa:"919876543211", specialty:"Singles & Footwork" },
  { id:3, name:"Syed Irfan",      sport:"football",   exp:"10 yrs", area:"Secunderabad",   ground:"YMCA Grounds",                       price:500,  rating:4.7, students:42, wa:"919876543212", specialty:"Dribbling & Tactics" },
  { id:4, name:"Anita Reddy",     sport:"tennis",     exp:"6 yrs",  area:"Banjara Hills",  ground:"Lal Bahadur Shastri Stadium",        price:900,  rating:4.6, students:18, wa:"919876543213", specialty:"Serve & Volley" },
  { id:5, name:"Mohammed Faiz",   sport:"cricket",    exp:"15 yrs", area:"Uppal",          ground:"Rajiv Gandhi International Stadium", price:1000, rating:5.0, students:56, wa:"919876543214", specialty:"Fast Bowling" },
  { id:6, name:"Deepa Nair",      sport:"pickleball", exp:"4 yrs",  area:"Hitech City",    ground:"Hitech City Badminton Academy",       price:700,  rating:4.7, students:22, wa:"919876543215", specialty:"Singles & Doubles" },
  { id:7, name:"Suresh Kumar",    sport:"hockey",     exp:"9 yrs",  area:"Secunderabad",   ground:"YMCA Grounds",                       price:550,  rating:4.5, students:30, wa:"919876543216", specialty:"Drag Flick & Defense" },
  { id:8, name:"Kiran Patel",     sport:"badminton",  exp:"11 yrs", area:"Gachibowli",     ground:"Gachibowli Stadium",                 price:650,  rating:4.8, students:38, wa:"919876543217", specialty:"Doubles & Smash" },
  { id:9, name:"Arjun Rao",       sport:"football",   exp:"7 yrs",  area:"Banjara Hills",  ground:"Lal Bahadur Shastri Stadium",        price:600,  rating:4.6, students:25, wa:"919876543218", specialty:"Goalkeeping" },
  { id:10,name:"Sneha Iyer",      sport:"tennis",     exp:"5 yrs",  area:"Gachibowli",     ground:"Gachibowli Stadium",                 price:850,  rating:4.7, students:20, wa:"919876543219", specialty:"Baseline & Rally" },
];

const PLAYERS = [
  { id:1,  name:"Rahul Verma",    sport:"cricket",    area:"Gachibowli",    level:"Intermediate", age:24, matches:45 },
  { id:2,  name:"Aisha Khan",     sport:"badminton",  area:"Hitech City",   level:"Beginner",     age:19, matches:12 },
  { id:3,  name:"Vijay Nair",     sport:"football",   area:"Secunderabad",  level:"Advanced",     age:26, matches:78 },
  { id:4,  name:"Meera Sharma",   sport:"tennis",     area:"Banjara Hills", level:"Intermediate", age:22, matches:33 },
  { id:5,  name:"Rohit Das",      sport:"cricket",    area:"Uppal",         level:"Advanced",     age:28, matches:120},
  { id:6,  name:"Preethi Raj",    sport:"pickleball", area:"Hitech City",   level:"Beginner",     age:21, matches:8  },
  { id:7,  name:"Sanjay Gupta",   sport:"hockey",     area:"Secunderabad",  level:"Intermediate", age:25, matches:55 },
  { id:8,  name:"Divya Reddy",    sport:"badminton",  area:"Gachibowli",    level:"Advanced",     age:23, matches:89 },
  { id:9,  name:"Imran Sheikh",   sport:"football",   area:"Banjara Hills", level:"Beginner",     age:18, matches:6  },
  { id:10, name:"Kavya Menon",    sport:"tennis",     area:"Gachibowli",    level:"Intermediate", age:27, matches:41 },
  { id:11, name:"Tarun Yadav",    sport:"cricket",    area:"Secunderabad",  level:"Beginner",     age:20, matches:15 },
  { id:12, name:"Lakshmi Prasad", sport:"hockey",     area:"Uppal",         level:"Advanced",     age:29, matches:95 },
];

const GROUNDS = [
  { id:1, name:"Gachibowli Stadium",                area:"Gachibowli",    sports:["cricket","badminton","tennis"], coaches:3, facilities:["Parking","Lights","Changing Room","Cafeteria"],   timing:"6AM–10PM", contact:"040-23456789" },
  { id:2, name:"Lal Bahadur Shastri Stadium",       area:"Secunderabad",  sports:["cricket","football","tennis"],  coaches:2, facilities:["Parking","Lights","Changing Room"],               timing:"5AM–9PM",  contact:"040-27891234" },
  { id:3, name:"YMCA Grounds",                      area:"Secunderabad",  sports:["football","hockey","cricket"],  coaches:2, facilities:["Parking","Changing Room","First Aid"],            timing:"6AM–8PM",  contact:"040-23456001" },
  { id:4, name:"Rajiv Gandhi International Stadium",area:"Uppal",         sports:["cricket"],                      coaches:1, facilities:["Parking","Lights","Changing Room","Cafeteria","Gym"], timing:"6AM–10PM", contact:"040-27654321" },
  { id:5, name:"Hitech City Badminton Academy",     area:"Hitech City",   sports:["badminton","pickleball"],       coaches:2, facilities:["AC Courts","Parking","Changing Room","Pro Shop"], timing:"6AM–10PM", contact:"040-29876543" },
];

const SCORES = [
  { id:1,  sport:"cricket",    team1:"Gachibowli XI",    score1:"187/4",  team2:"Hitech Strikers", score2:"165/8",  overs:"20",  status:"completed", winner:"Gachibowli XI",    date:"Today",      area:"Gachibowli"   },
  { id:2,  sport:"football",   team1:"Secunderabad FC",  score1:"3",      team2:"Banjara United",  score2:"2",      overs:"90'", status:"completed", winner:"Secunderabad FC",  date:"Today",      area:"Secunderabad" },
  { id:3,  sport:"cricket",    team1:"Uppal Warriors",   score1:"142/6",  team2:"Miyapur Lions",   score2:"98/10",  overs:"15",  status:"completed", winner:"Uppal Warriors",   date:"Yesterday",  area:"Uppal"        },
  { id:4,  sport:"badminton",  team1:"Rahul Verma",      score1:"21,18",  team2:"Kiran Patel",     score2:"15,21",  overs:"3",   status:"completed", winner:"Kiran Patel",      date:"Yesterday",  area:"Gachibowli"   },
  { id:5,  sport:"hockey",     team1:"Secunderabad HC",  score1:"4",      team2:"Uppal Tigers",    score2:"4",      overs:"60'", status:"completed", winner:"Draw",             date:"2 days ago",  area:"Secunderabad" },
  { id:6,  sport:"cricket",    team1:"Banjara Blues",    score1:"211/3",  team2:"YMCA Challengers",score2:"*",      overs:"15",  status:"live",      winner:null,               date:"Live",       area:"Banjara Hills"},
  { id:7,  sport:"football",   team1:"Hitech City FC",   score1:"1",      team2:"Gachibowli FC",   score2:"*",      overs:"67'", status:"live",      winner:null,               date:"Live",       area:"Hitech City"  },
  { id:8,  sport:"tennis",     team1:"Meera Sharma",     score1:"6-4,3",  team2:"Kavya Menon",     score2:"2-6,2",  overs:"Set 3",status:"live",     winner:null,               date:"Live",       area:"Banjara Hills"},
];

const STORE_ITEMS = [
  { id:1,  sport:"cricket",    name:"Pro Cricket Bat",         brand:"SS",       price:2499, rating:4.7, tag:"Bestseller" },
  { id:2,  sport:"cricket",    name:"Batting Gloves",          brand:"SG",       price:699,  rating:4.5, tag:"" },
  { id:3,  sport:"badminton",  name:"Yonex Racket",            brand:"Yonex",    price:1899, rating:4.9, tag:"Top Rated" },
  { id:4,  sport:"football",   name:"Nike Football",           brand:"Nike",     price:1299, rating:4.6, tag:"" },
  { id:5,  sport:"tennis",     name:"Wilson Tennis Racket",    brand:"Wilson",   price:3499, rating:4.8, tag:"Premium" },
  { id:6,  sport:"cricket",    name:"Batting Pads",            brand:"GM",       price:1599, rating:4.4, tag:"" },
  { id:7,  sport:"badminton",  name:"Badminton Shuttles (12)", brand:"Yonex",    price:449,  rating:4.7, tag:"" },
  { id:8,  sport:"hockey",     name:"Hockey Stick",            brand:"Adidas",   price:1999, rating:4.5, tag:"" },
  { id:9,  sport:"football",   name:"Football Boots",          brand:"Adidas",   price:2299, rating:4.6, tag:"New" },
  { id:10, sport:"pickleball", name:"Pickleball Paddle",       brand:"Selkirk",  price:4999, rating:4.8, tag:"Premium" },
];

// ── SCORE ENTRY SCREEN ────────────────────────────────────────────────────────
function ScoreEntryScreen({ onBack }) {
  const [sport, setSport] = useState("cricket");
  const [team1, setTeam1] = useState("");
  const [team2, setTeam2] = useState("");
  const [score1, setScore1] = useState("");
  const [score2, setScore2] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const inp = { width:"100%", padding:"11px 14px", borderRadius:10, border:`1px solid ${C.border}`, fontSize:14, color:C.text, boxSizing:"border-box", fontFamily:"inherit", outline:"none", background:C.white };

  if(submitted) return(
    <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:16,padding:32,textAlign:"center"}}>
      <div style={{width:64,height:64,borderRadius:"50%",background:C.orangeL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:32}}>✅</div>
      <div style={{fontSize:20,fontWeight:800,color:C.text}}>Score Submitted!</div>
      <div style={{fontSize:14,color:C.sub}}>Your match score has been recorded successfully.</div>
      <button onClick={onBack} style={{padding:"12px 28px",borderRadius:10,border:"none",background:C.orange,color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>Back to Scores</button>
    </div>
  );

  return(
    <div style={{flex:1,overflowY:"auto",padding:16}}>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
        <button onClick={onBack} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:C.text,padding:0}}>←</button>
        <div style={{fontSize:18,fontWeight:800,color:C.text}}>Enter Match Score</div>
      </div>

      {/* Sport picker */}
      <div style={{marginBottom:16}}>
        <div style={{fontSize:12,fontWeight:700,color:C.sub,marginBottom:8,textTransform:"uppercase",letterSpacing:1}}>Sport</div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          {SPORTS.filter(s=>s.id!=="all").map(s=>(
            <button key={s.id} onClick={()=>setSport(s.id)} style={{padding:"7px 14px",borderRadius:20,border:`1px solid ${sport===s.id?sportColor(s.id):"#eee"}`,background:sport===s.id?sportColor(s.id)+"15":C.white,color:sport===s.id?sportColor(s.id):C.sub,fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
              {s.emoji} {s.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        <div>
          <div style={{fontSize:12,fontWeight:700,color:C.sub,marginBottom:6,textTransform:"uppercase",letterSpacing:1}}>Team / Player 1</div>
          <input value={team1} onChange={e=>setTeam1(e.target.value)} placeholder="Enter team or player name" style={inp}/>
        </div>
        <div>
          <div style={{fontSize:12,fontWeight:700,color:C.sub,marginBottom:6,textTransform:"uppercase",letterSpacing:1}}>Score</div>
          <input value={score1} onChange={e=>setScore1(e.target.value)} placeholder={sport==="cricket"?"e.g. 187/4 (20 overs)":sport==="football"?"e.g. 3":"e.g. 21-15"} style={inp}/>
        </div>
        <div style={{textAlign:"center",fontSize:14,fontWeight:700,color:C.muted}}>VS</div>
        <div>
          <div style={{fontSize:12,fontWeight:700,color:C.sub,marginBottom:6,textTransform:"uppercase",letterSpacing:1}}>Team / Player 2</div>
          <input value={team2} onChange={e=>setTeam2(e.target.value)} placeholder="Enter team or player name" style={inp}/>
        </div>
        <div>
          <div style={{fontSize:12,fontWeight:700,color:C.sub,marginBottom:6,textTransform:"uppercase",letterSpacing:1}}>Score</div>
          <input value={score2} onChange={e=>setScore2(e.target.value)} placeholder={sport==="cricket"?"e.g. 165/8 (20 overs)":sport==="football"?"e.g. 2":"e.g. 18-21"} style={inp}/>
        </div>
        <button onClick={()=>{if(team1&&team2&&score1&&score2)setSubmitted(true);}} style={{marginTop:8,padding:"14px",borderRadius:12,border:"none",background:C.orange,color:"#fff",fontSize:15,fontWeight:800,cursor:"pointer",fontFamily:"inherit",opacity:team1&&team2&&score1&&score2?1:0.5}}>
          Submit Score
        </button>
      </div>
    </div>
  );
}

// ── SCREENS ───────────────────────────────────────────────────────────────────
function CoachesScreen() {
  const [sport, setSport] = useState("all");
  const [area, setArea] = useState("all");
  const areas = ["all","Gachibowli","Hitech City","Secunderabad","Banjara Hills","Uppal"];
  const filtered = COACHES.filter(c=>(sport==="all"||c.sport===sport)&&(area==="all"||c.area===area));

  return(
    <div style={{flex:1,overflowY:"auto",background:C.bg}}>
      {/* Header */}
      <div style={{background:C.white,padding:"20px 16px 0",borderBottom:`1px solid ${C.border}`}}>
        <div style={{fontSize:22,fontWeight:900,color:C.text,marginBottom:2}}>Find a Coach</div>
        <div style={{fontSize:13,color:C.sub,marginBottom:14}}>{COACHES.length} coaches across Hyderabad</div>
        {/* Sport filter */}
        <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:14}}>
          {SPORTS.map(s=>(
            <button key={s.id} onClick={()=>setSport(s.id)} style={{flexShrink:0,padding:"7px 14px",borderRadius:20,border:`1.5px solid ${sport===s.id?sportColor(s.id):C.border}`,background:sport===s.id?sportColor(s.id):C.white,color:sport===s.id?"#fff":C.sub,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit",transition:"all 0.15s"}}>
              {s.emoji} {s.label}
            </button>
          ))}
        </div>
        {/* Area filter */}
        <div style={{display:"flex",gap:6,overflowX:"auto",paddingBottom:14}}>
          {areas.map(a=>(
            <button key={a} onClick={()=>setArea(a)} style={{flexShrink:0,padding:"5px 12px",borderRadius:16,border:`1px solid ${area===a?C.orange:C.border}`,background:area===a?C.orangeL:C.white,color:area===a?C.orange:C.sub,fontSize:11,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
              {a==="all"?"📍 All Areas":a}
            </button>
          ))}
        </div>
      </div>

      <div style={{padding:14,display:"flex",flexDirection:"column",gap:12}}>
        {filtered.length===0&&<div style={{textAlign:"center",padding:40,color:C.muted}}>No coaches found. Try another filter.</div>}
        {filtered.map(coach=>{
          const sc = sportColor(coach.sport);
          return(
            <div key={coach.id} style={{background:C.white,borderRadius:14,padding:16,boxShadow:"0 1px 8px rgba(0,0,0,0.07)",border:`1px solid ${C.border}`}}>
              <div style={{display:"flex",gap:12,alignItems:"flex-start"}}>
                {/* Avatar */}
                <div style={{width:52,height:52,borderRadius:12,background:sc+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0,border:`2px solid ${sc}22`}}>
                  {sportEmoji(coach.sport)}
                </div>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:2}}>
                    <div style={{fontSize:16,fontWeight:800,color:C.text}}>{coach.name}</div>
                    <div style={{fontSize:13,fontWeight:700,color:C.orange}}>₹{coach.price}<span style={{fontSize:10,color:C.muted,fontWeight:400}}>/session</span></div>
                  </div>
                  <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:6,flexWrap:"wrap"}}>
                    <span style={{padding:"2px 8px",borderRadius:10,background:sc+"15",color:sc,fontSize:11,fontWeight:700}}>{sportEmoji(coach.sport)} {coach.sport}</span>
                    <span style={{fontSize:11,color:C.muted}}>•</span>
                    <span style={{fontSize:11,color:C.sub}}>{coach.exp} exp</span>
                    <span style={{fontSize:11,color:C.muted}}>•</span>
                    <span style={{fontSize:11,color:"#f59e0b"}}>⭐ {coach.rating}</span>
                  </div>
                  <div style={{fontSize:12,color:C.sub,marginBottom:4}}>🎯 {coach.specialty}</div>
                  <div style={{fontSize:12,color:C.sub,marginBottom:4}}>📍 {coach.ground}</div>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:8}}>
                    <div style={{fontSize:11,color:C.muted}}>👥 {coach.students} students</div>
                    <button onClick={()=>window.open(`https://wa.me/${coach.wa}?text=${encodeURIComponent(`Hi ${coach.name}! I found you on Takkar.app. I'm interested in ${coach.sport} coaching sessions. Can you share more details?`)}`,"_blank")} style={{padding:"7px 14px",borderRadius:8,border:"none",background:"#25D366",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",gap:5}}>
                      💬 WhatsApp
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function PlayersScreen() {
  const [sport, setSport] = useState("all");
  const [level, setLevel] = useState("all");
  const levels = ["all","Beginner","Intermediate","Advanced"];
  const filtered = PLAYERS.filter(p=>(sport==="all"||p.sport===sport)&&(level==="all"||p.level===level));

  return(
    <div style={{flex:1,overflowY:"auto",background:C.bg}}>
      <div style={{background:C.white,padding:"20px 16px 0",borderBottom:`1px solid ${C.border}`}}>
        <div style={{fontSize:22,fontWeight:900,color:C.text,marginBottom:2}}>Find Players</div>
        <div style={{fontSize:13,color:C.sub,marginBottom:14}}>{PLAYERS.length} players in Hyderabad</div>
        <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:14}}>
          {SPORTS.map(s=>(
            <button key={s.id} onClick={()=>setSport(s.id)} style={{flexShrink:0,padding:"7px 14px",borderRadius:20,border:`1.5px solid ${sport===s.id?sportColor(s.id):C.border}`,background:sport===s.id?sportColor(s.id):C.white,color:sport===s.id?"#fff":C.sub,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit",transition:"all 0.15s"}}>
              {s.emoji} {s.label}
            </button>
          ))}
        </div>
        <div style={{display:"flex",gap:6,paddingBottom:14}}>
          {levels.map(l=>(
            <button key={l} onClick={()=>setLevel(l)} style={{padding:"5px 12px",borderRadius:16,border:`1px solid ${level===l?C.orange:C.border}`,background:level===l?C.orangeL:C.white,color:level===l?C.orange:C.sub,fontSize:11,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>
              {l==="all"?"All Levels":l}
            </button>
          ))}
        </div>
      </div>

      <div style={{padding:14,display:"flex",flexDirection:"column",gap:10}}>
        {filtered.length===0&&<div style={{textAlign:"center",padding:40,color:C.muted}}>No players found.</div>}
        {filtered.map(p=>{
          const sc=sportColor(p.sport);
          const initials=p.name.split(" ").map(n=>n[0]).join("");
          const levelColor={Beginner:C.green,Intermediate:C.blue,Advanced:C.orange}[p.level];
          return(
            <div key={p.id} style={{background:C.white,borderRadius:14,padding:14,boxShadow:"0 1px 6px rgba(0,0,0,0.06)",border:`1px solid ${C.border}`,display:"flex",gap:12,alignItems:"center"}}>
              <div style={{width:46,height:46,borderRadius:"50%",background:sc+"20",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:800,color:sc,flexShrink:0,border:`2px solid ${sc}30`}}>
                {initials}
              </div>
              <div style={{flex:1}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:3}}>
                  <div style={{fontSize:15,fontWeight:800,color:C.text}}>{p.name}</div>
                  <span style={{padding:"2px 8px",borderRadius:10,background:levelColor+"18",color:levelColor,fontSize:10,fontWeight:700}}>{p.level}</span>
                </div>
                <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                  <span style={{fontSize:11,color:sc,fontWeight:600}}>{sportEmoji(p.sport)} {p.sport}</span>
                  <span style={{fontSize:11,color:C.muted}}>•</span>
                  <span style={{fontSize:11,color:C.sub}}>📍 {p.area}</span>
                  <span style={{fontSize:11,color:C.muted}}>•</span>
                  <span style={{fontSize:11,color:C.sub}}>🎮 {p.matches} matches</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function ScoresScreen() {
  const [sport, setSport] = useState("all");
  const [showEntry, setShowEntry] = useState(false);
  const filtered = SCORES.filter(s=>sport==="all"||s.sport===sport);
  const live = filtered.filter(s=>s.status==="live");
  const completed = filtered.filter(s=>s.status==="completed");

  if(showEntry) return <ScoreEntryScreen onBack={()=>setShowEntry(false)}/>;

  return(
    <div style={{flex:1,overflowY:"auto",background:C.bg}}>
      <div style={{background:C.white,padding:"20px 16px 0",borderBottom:`1px solid ${C.border}`}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:2}}>
          <div style={{fontSize:22,fontWeight:900,color:C.text}}>Scores</div>
          <button onClick={()=>setShowEntry(true)} style={{padding:"8px 14px",borderRadius:10,border:"none",background:C.orange,color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>+ Add Score</button>
        </div>
        <div style={{fontSize:13,color:C.sub,marginBottom:14}}>{live.length} live · {completed.length} completed</div>
        <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:14}}>
          {SPORTS.map(s=>(
            <button key={s.id} onClick={()=>setSport(s.id)} style={{flexShrink:0,padding:"7px 14px",borderRadius:20,border:`1.5px solid ${sport===s.id?sportColor(s.id):C.border}`,background:sport===s.id?sportColor(s.id):C.white,color:sport===s.id?"#fff":C.sub,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
              {s.emoji} {s.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{padding:14}}>
        {live.length>0&&(
          <>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:10}}>
              <div style={{width:7,height:7,borderRadius:"50%",background:C.red,animation:"pulse 1.5s infinite"}}></div>
              <div style={{fontSize:12,fontWeight:800,color:C.red,letterSpacing:1,textTransform:"uppercase"}}>Live Now</div>
            </div>
            <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.3}}`}</style>
            {live.map(s=>{
              const sc=sportColor(s.sport);
              return(
                <div key={s.id} style={{background:C.white,borderRadius:14,padding:16,marginBottom:10,border:`2px solid ${C.red}30`,boxShadow:"0 2px 12px rgba(220,38,38,0.08)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                    <span style={{padding:"2px 8px",borderRadius:8,background:sc+"15",color:sc,fontSize:11,fontWeight:700}}>{sportEmoji(s.sport)} {s.sport}</span>
                    <span style={{padding:"2px 8px",borderRadius:8,background:"#FEE2E2",color:C.red,fontSize:11,fontWeight:700}}>● LIVE · {s.overs}</span>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <div style={{flex:1,textAlign:"center"}}>
                      <div style={{fontSize:13,fontWeight:800,color:C.text,marginBottom:3}}>{s.team1}</div>
                      <div style={{fontSize:22,fontWeight:900,color:C.orange,fontFamily:"monospace"}}>{s.score1}</div>
                    </div>
                    <div style={{fontSize:14,fontWeight:800,color:C.muted,padding:"0 4px"}}>VS</div>
                    <div style={{flex:1,textAlign:"center"}}>
                      <div style={{fontSize:13,fontWeight:800,color:C.text,marginBottom:3}}>{s.team2}</div>
                      <div style={{fontSize:22,fontWeight:900,color:C.sub,fontFamily:"monospace"}}>{s.score2==="*"?"Batting":s.score2}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}

        {completed.length>0&&(
          <>
            <div style={{fontSize:12,fontWeight:800,color:C.sub,letterSpacing:1,textTransform:"uppercase",marginBottom:10,marginTop:4}}>Recent Results</div>
            {completed.map(s=>{
              const sc=sportColor(s.sport);
              return(
                <div key={s.id} style={{background:C.white,borderRadius:12,padding:14,marginBottom:8,border:`1px solid ${C.border}`,boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <span style={{padding:"2px 8px",borderRadius:8,background:sc+"15",color:sc,fontSize:11,fontWeight:700}}>{sportEmoji(s.sport)} {s.sport}</span>
                    <span style={{fontSize:11,color:C.muted}}>{s.date} · {s.area}</span>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    <div style={{flex:1,textAlign:"center"}}>
                      <div style={{fontSize:12,fontWeight:700,color:s.winner===s.team1?C.text:C.muted,marginBottom:2}}>{s.team1}</div>
                      <div style={{fontSize:18,fontWeight:900,color:s.winner===s.team1?C.orange:C.muted,fontFamily:"monospace"}}>{s.score1}</div>
                    </div>
                    <div style={{fontSize:12,fontWeight:700,color:C.muted}}>VS</div>
                    <div style={{flex:1,textAlign:"center"}}>
                      <div style={{fontSize:12,fontWeight:700,color:s.winner===s.team2?C.text:C.muted,marginBottom:2}}>{s.team2}</div>
                      <div style={{fontSize:18,fontWeight:900,color:s.winner===s.team2?C.orange:C.muted,fontFamily:"monospace"}}>{s.score2}</div>
                    </div>
                  </div>
                  {s.winner&&<div style={{marginTop:8,textAlign:"center",fontSize:11,color:C.green,fontWeight:700}}>🏆 {s.winner==="Draw"?"Match Drawn":`${s.winner} won`}</div>}
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
}

function GroundsScreen() {
  const [sport, setSport] = useState("all");
  const [selected, setSelected] = useState(null);
  const filtered = GROUNDS.filter(g=>sport==="all"||g.sports.includes(sport));

  if(selected){
    const g=selected;
    const groundCoaches=COACHES.filter(c=>c.ground===g.name);
    return(
      <div style={{flex:1,overflowY:"auto",background:C.bg}}>
        <div style={{background:C.white,padding:"16px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",gap:12}}>
          <button onClick={()=>setSelected(null)} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:C.text,padding:0}}>←</button>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:C.text,lineHeight:1.2}}>{g.name}</div>
            <div style={{fontSize:12,color:C.sub}}>📍 {g.area}</div>
          </div>
        </div>
        <div style={{padding:14}}>
          {/* Sports */}
          <div style={{background:C.white,borderRadius:12,padding:14,marginBottom:12,border:`1px solid ${C.border}`}}>
            <div style={{fontSize:12,fontWeight:800,color:C.sub,letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>Sports Available</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {g.sports.map(s=><span key={s} style={{padding:"5px 12px",borderRadius:16,background:sportColor(s)+"15",color:sportColor(s),fontSize:12,fontWeight:700}}>{sportEmoji(s)} {s}</span>)}
            </div>
          </div>
          {/* Facilities */}
          <div style={{background:C.white,borderRadius:12,padding:14,marginBottom:12,border:`1px solid ${C.border}`}}>
            <div style={{fontSize:12,fontWeight:800,color:C.sub,letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>Facilities</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {g.facilities.map(f=><span key={f} style={{padding:"4px 10px",borderRadius:8,background:C.bg,color:C.sub,fontSize:12,border:`1px solid ${C.border}`}}>✓ {f}</span>)}
            </div>
          </div>
          {/* Timing & Contact */}
          <div style={{background:C.white,borderRadius:12,padding:14,marginBottom:12,border:`1px solid ${C.border}`}}>
            <div style={{display:"flex",justifyContent:"space-between"}}>
              <div><div style={{fontSize:11,color:C.muted,marginBottom:3}}>TIMINGS</div><div style={{fontSize:14,fontWeight:700,color:C.text}}>🕐 {g.timing}</div></div>
              <div><div style={{fontSize:11,color:C.muted,marginBottom:3}}>CONTACT</div><div style={{fontSize:14,fontWeight:700,color:C.orange}}>📞 {g.contact}</div></div>
            </div>
          </div>
          {/* Coaches at this ground */}
          {groundCoaches.length>0&&(
            <div>
              <div style={{fontSize:12,fontWeight:800,color:C.sub,letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>{groundCoaches.length} Coaches Here</div>
              {groundCoaches.map(coach=>{
                const sc=sportColor(coach.sport);
                return(
                  <div key={coach.id} style={{background:C.white,borderRadius:12,padding:14,marginBottom:8,border:`1px solid ${C.border}`,display:"flex",alignItems:"center",gap:12}}>
                    <div style={{width:42,height:42,borderRadius:10,background:sc+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{sportEmoji(coach.sport)}</div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:14,fontWeight:800,color:C.text,marginBottom:2}}>{coach.name}</div>
                      <div style={{fontSize:11,color:C.sub}}>{coach.specialty} · ⭐{coach.rating} · ₹{coach.price}/session</div>
                    </div>
                    <button onClick={()=>window.open(`https://wa.me/${coach.wa}?text=${encodeURIComponent(`Hi ${coach.name}! I found you on Takkar.app at ${g.name}. Interested in coaching!`)}`,"_blank")} style={{padding:"6px 10px",borderRadius:8,border:"none",background:"#25D366",color:"#fff",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>💬</button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }

  return(
    <div style={{flex:1,overflowY:"auto",background:C.bg}}>
      <div style={{background:C.white,padding:"20px 16px 0",borderBottom:`1px solid ${C.border}`}}>
        <div style={{fontSize:22,fontWeight:900,color:C.text,marginBottom:2}}>Grounds & Academies</div>
        <div style={{fontSize:13,color:C.sub,marginBottom:14}}>Top venues in Hyderabad</div>
        <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:14}}>
          {SPORTS.map(s=>(
            <button key={s.id} onClick={()=>setSport(s.id)} style={{flexShrink:0,padding:"7px 14px",borderRadius:20,border:`1.5px solid ${sport===s.id?sportColor(s.id):C.border}`,background:sport===s.id?sportColor(s.id):C.white,color:sport===s.id?"#fff":C.sub,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
              {s.emoji} {s.label}
            </button>
          ))}
        </div>
      </div>
      <div style={{padding:14,display:"flex",flexDirection:"column",gap:12}}>
        {filtered.map(g=>(
          <div key={g.id} onClick={()=>setSelected(g)} style={{background:C.white,borderRadius:14,padding:16,boxShadow:"0 1px 8px rgba(0,0,0,0.07)",border:`1px solid ${C.border}`,cursor:"pointer"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:C.text,marginBottom:2}}>{g.name}</div>
                <div style={{fontSize:12,color:C.sub}}>📍 {g.area}</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontSize:12,fontWeight:700,color:C.orange,marginBottom:2}}>🕐 {g.timing}</div>
                <div style={{fontSize:11,color:C.muted}}>👨‍🏫 {g.coaches} coaches</div>
              </div>
            </div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10}}>
              {g.sports.map(s=><span key={s} style={{padding:"3px 8px",borderRadius:8,background:sportColor(s)+"15",color:sportColor(s),fontSize:11,fontWeight:700}}>{sportEmoji(s)}</span>)}
            </div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {g.facilities.slice(0,3).map(f=><span key={f} style={{padding:"3px 8px",borderRadius:6,background:C.bg,color:C.muted,fontSize:10,border:`1px solid ${C.border}`}}>✓ {f}</span>)}
              {g.facilities.length>3&&<span style={{padding:"3px 8px",borderRadius:6,background:C.bg,color:C.muted,fontSize:10}}>+{g.facilities.length-3} more</span>}
            </div>
            <div style={{marginTop:10,textAlign:"right",fontSize:12,color:C.orange,fontWeight:700}}>View Details →</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function StoreScreen() {
  const [sport, setSport] = useState("all");
  const filtered = STORE_ITEMS.filter(i=>sport==="all"||i.sport===sport);

  return(
    <div style={{flex:1,overflowY:"auto",background:C.bg}}>
      <div style={{background:C.white,padding:"20px 16px 0",borderBottom:`1px solid ${C.border}`}}>
        <div style={{fontSize:22,fontWeight:900,color:C.text,marginBottom:2}}>Store</div>
        <div style={{fontSize:13,color:C.sub,marginBottom:14}}>Top sports gear for every sport</div>
        <div style={{display:"flex",gap:8,overflowX:"auto",paddingBottom:14}}>
          {SPORTS.map(s=>(
            <button key={s.id} onClick={()=>setSport(s.id)} style={{flexShrink:0,padding:"7px 14px",borderRadius:20,border:`1.5px solid ${sport===s.id?sportColor(s.id):C.border}`,background:sport===s.id?sportColor(s.id):C.white,color:sport===s.id?"#fff":C.sub,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
              {s.emoji} {s.label}
            </button>
          ))}
        </div>
      </div>
      <div style={{padding:14,display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        {filtered.map(item=>{
          const sc=sportColor(item.sport);
          return(
            <div key={item.id} style={{background:C.white,borderRadius:14,padding:14,boxShadow:"0 1px 6px rgba(0,0,0,0.06)",border:`1px solid ${C.border}`,position:"relative"}}>
              {item.tag&&<div style={{position:"absolute",top:10,right:10,padding:"2px 7px",borderRadius:6,background:C.orange,color:"#fff",fontSize:9,fontWeight:800}}>{item.tag}</div>}
              <div style={{width:"100%",height:80,borderRadius:10,background:sc+"12",display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,marginBottom:10}}>{sportEmoji(item.sport)}</div>
              <div style={{fontSize:13,fontWeight:800,color:C.text,marginBottom:2,lineHeight:1.3}}>{item.name}</div>
              <div style={{fontSize:11,color:C.muted,marginBottom:6}}>{item.brand} · ⭐{item.rating}</div>
              <div style={{fontSize:16,fontWeight:900,color:C.orange,marginBottom:10}}>₹{item.price.toLocaleString("en-IN")}</div>
              <button style={{width:"100%",padding:"8px",borderRadius:8,border:`1px solid ${C.orange}`,background:C.orangeL,color:C.orange,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>Add to Cart</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function ProfileScreen() {
  const [sport, setSport] = useState("cricket");
  return(
    <div style={{flex:1,overflowY:"auto",background:C.bg}}>
      {/* Profile header */}
      <div style={{background:`linear-gradient(135deg,${C.orange},${C.orange2})`,padding:"28px 20px 20px",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:-20,right:-20,width:100,height:100,borderRadius:"50%",background:"rgba(255,255,255,0.1)"}}/>
        <div style={{display:"flex",gap:14,alignItems:"center",marginBottom:16}}>
          <div style={{width:60,height:60,borderRadius:"50%",background:"rgba(255,255,255,0.25)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,fontWeight:900,color:"#fff",border:"2px solid rgba(255,255,255,0.5)"}}>AP</div>
          <div>
            <div style={{fontSize:18,fontWeight:900,color:"#fff"}}>Abhilash PV</div>
            <div style={{fontSize:12,color:"rgba(255,255,255,0.8)"}}>📍 Hyderabad · Member since 2024</div>
          </div>
        </div>
        <div style={{display:"flex",gap:16}}>
          {[{l:"Matches",v:"23"},{l:"Wins",v:"15"},{l:"Sports",v:"3"}].map(s=>(
            <div key={s.l} style={{textAlign:"center"}}>
              <div style={{fontSize:20,fontWeight:900,color:"#fff"}}>{s.v}</div>
              <div style={{fontSize:10,color:"rgba(255,255,255,0.75)",fontWeight:600}}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{padding:14}}>
        {/* Sport selector */}
        <div style={{background:C.white,borderRadius:14,padding:14,marginBottom:12,border:`1px solid ${C.border}`}}>
          <div style={{fontSize:12,fontWeight:800,color:C.sub,letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>My Sports</div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {SPORTS.filter(s=>s.id!=="all").map(s=>(
              <button key={s.id} onClick={()=>setSport(s.id)} style={{padding:"7px 14px",borderRadius:20,border:`1.5px solid ${sport===s.id?sportColor(s.id):C.border}`,background:sport===s.id?sportColor(s.id)+"15":C.white,color:sport===s.id?sportColor(s.id):C.sub,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit"}}>
                {s.emoji} {s.label}
              </button>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div style={{background:C.white,borderRadius:14,padding:14,marginBottom:12,border:`1px solid ${C.border}`}}>
          <div style={{fontSize:12,fontWeight:800,color:C.sub,letterSpacing:1,textTransform:"uppercase",marginBottom:12}}>{sportEmoji(sport)} {sport} Stats</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            {sport==="cricket"&&[{l:"Matches",v:"15"},{l:"Runs",v:"487"},{l:"Wickets",v:"12"},{l:"Avg",v:"32.4"}].map(s=>(
              <div key={s.l} style={{background:C.bg,borderRadius:10,padding:12,textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:900,color:C.orange}}>{s.v}</div>
                <div style={{fontSize:11,color:C.muted,marginTop:2}}>{s.l}</div>
              </div>
            ))}
            {sport==="badminton"&&[{l:"Matches",v:"8"},{l:"Wins",v:"5"},{l:"Sets Won",v:"12"},{l:"Win %",v:"62%"}].map(s=>(
              <div key={s.l} style={{background:C.bg,borderRadius:10,padding:12,textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:900,color:C.blue}}>{s.v}</div>
                <div style={{fontSize:11,color:C.muted,marginTop:2}}>{s.l}</div>
              </div>
            ))}
            {["football","tennis","pickleball","hockey"].includes(sport)&&[{l:"Matches",v:"5"},{l:"Wins",v:"3"},{l:"Goals/Pts",v:"8"},{l:"Win %",v:"60%"}].map(s=>(
              <div key={s.l} style={{background:C.bg,borderRadius:10,padding:12,textAlign:"center"}}>
                <div style={{fontSize:22,fontWeight:900,color:sportColor(sport)}}>{s.v}</div>
                <div style={{fontSize:11,color:C.muted,marginTop:2}}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Recent activity */}
        <div style={{background:C.white,borderRadius:14,padding:14,border:`1px solid ${C.border}`}}>
          <div style={{fontSize:12,fontWeight:800,color:C.sub,letterSpacing:1,textTransform:"uppercase",marginBottom:12}}>Recent Activity</div>
          {[
            {sport:"cricket",  desc:"Scored 54 runs vs Hitech Strikers", date:"2 days ago",  result:"won"},
            {sport:"badminton",desc:"Won 21-15, 21-18 vs Kiran Patel",   date:"4 days ago",  result:"won"},
            {sport:"football", desc:"Assisted 2 goals vs Banjara FC",    date:"1 week ago",  result:"lost"},
          ].map((a,i)=>(
            <div key={i} style={{display:"flex",gap:10,alignItems:"center",paddingBottom:10,marginBottom:10,borderBottom:i<2?`1px solid ${C.border}`:"none"}}>
              <div style={{width:36,height:36,borderRadius:9,background:sportColor(a.sport)+"15",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>{sportEmoji(a.sport)}</div>
              <div style={{flex:1}}>
                <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:1}}>{a.desc}</div>
                <div style={{fontSize:11,color:C.muted}}>{a.date}</div>
              </div>
              <span style={{padding:"2px 7px",borderRadius:6,background:a.result==="won"?"#DCFCE7":"#FEE2E2",color:a.result==="won"?C.green:C.red,fontSize:10,fontWeight:700}}>{a.result}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── ROOT APP ──────────────────────────────────────────────────────────────────
const TABS = [
  { id:"coaches",  label:"Coaches",  emoji:"👨‍🏫" },
  { id:"players",  label:"Players",  emoji:"👥"  },
  { id:"scores",   label:"Scores",   emoji:"📊"  },
  { id:"grounds",  label:"Grounds",  emoji:"🏟️" },
  { id:"store",    label:"Store",    emoji:"🛒"  },
];

export default function TakkarApp() {
  const [tab, setTab] = useState("coaches");

  return(
    <div style={{maxWidth:430,margin:"0 auto",height:"100vh",display:"flex",flexDirection:"column",background:C.white,fontFamily:"'Segoe UI','Helvetica Neue',Arial,sans-serif",position:"relative",overflow:"hidden"}}>

      {/* Top bar */}
      <div style={{background:C.white,borderBottom:`1px solid ${C.border}`,padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{width:32,height:32,borderRadius:8,background:C.orange,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>⚡</div>
          <div style={{fontSize:18,fontWeight:900,color:C.text,letterSpacing:-0.5}}>takkar</div>
          <div style={{fontSize:10,color:C.orange,fontWeight:700,background:C.orangeL,padding:"2px 6px",borderRadius:4}}>BETA</div>
        </div>
        <div style={{fontSize:12,color:C.sub}}>📍 Hyderabad</div>
      </div>

      {/* Screen */}
      <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
        {tab==="coaches" && <CoachesScreen/>}
        {tab==="players" && <PlayersScreen/>}
        {tab==="scores"  && <ScoresScreen/>}
        {tab==="grounds" && <GroundsScreen/>}
        {tab==="store"   && <StoreScreen/>}
        {tab==="profile" && <ProfileScreen/>}
      </div>

      {/* Bottom Nav */}
      <div style={{background:C.white,borderTop:`1px solid ${C.border}`,display:"flex",flexShrink:0,paddingBottom:"env(safe-area-inset-bottom,0px)"}}>
        {TABS.map(t=>{
          const active = tab===t.id;
          return(
            <button key={t.id} onClick={()=>setTab(t.id)} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:2,padding:"10px 0 8px",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit",position:"relative"}}>
              {active&&<div style={{position:"absolute",top:0,left:"50%",transform:"translateX(-50%)",width:24,height:2.5,borderRadius:2,background:C.orange}}/>}
              <span style={{fontSize:18,lineHeight:1}}>{t.emoji}</span>
              <span style={{fontSize:9,fontWeight:active?800:500,color:active?C.orange:C.muted,letterSpacing:0.3,textTransform:"uppercase"}}>{t.label}</span>
            </button>
          );
        })}
        <button onClick={()=>setTab("profile")} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:2,padding:"10px 0 8px",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit",position:"relative"}}>
          {tab==="profile"&&<div style={{position:"absolute",top:0,left:"50%",transform:"translateX(-50%)",width:24,height:2.5,borderRadius:2,background:C.orange}}/>}
          <span style={{fontSize:18,lineHeight:1}}>👤</span>
          <span style={{fontSize:9,fontWeight:tab==="profile"?800:500,color:tab==="profile"?C.orange:C.muted,letterSpacing:0.3,textTransform:"uppercase"}}>Profile</span>
        </button>
      </div>

      {/* Trust bar */}
      <div style={{background:C.bg,borderTop:`1px solid ${C.border}`,padding:"5px 0",textAlign:"center",flexShrink:0}}>
        <span style={{fontSize:9,color:C.muted,fontWeight:500}}>🇮🇳 Made in India · 🔒 Data Safe · ⭐ Since 2006 · ✅ Registered & Licensed under Govt. Act</span>
      </div>
    </div>
  );
}
